export enum SameSite {
  strict = 'strict',
  lax = 'lax',
  none = 'none'
}
